<ng-container *ngIf="fitnessTrackersList$ | async as fitnessTrackersList">
  <p class="fitness-tracker-subheading font-size-14">
    {{
      'fitness.tracker.card.subheading'
        | translate : { fgbdefault: 'Link your fitness tracker accounts to your loyalty account to take part in challenges.' }
    }}
  </p>

  <div class="fitness-tracker-list">
    <div class="fitness-tracker-row" *ngFor="let fitnessTracker of fitnessTrackersList">
      <div class="fitness-tracker-row-main">
        <div class="fitness-tracker-icon">
          <img
            [src]="'fitness-tracker/' + providers[fitnessTracker.ProviderId] + '.svg' | lowercase | contentAssetImage"
            alt=""
          />
        </div>
        <div class="fitness-tracker-row-info">
          <span class="fitness-tracker-row-name">{{ providers[fitnessTracker.ProviderId] }}</span>
          <span class="fitness-tracker-row-status" [ngClass]="fitnessTracker.HasConnection ? 'text-success' : 'text-info'">
            <ng-container *ngIf="fitnessTracker.HasConnection; else notConnectedStatus">
              {{ 'fitness.tracker.connected.text' | translate : { fgbdefault: 'Connected' } }}
              {{ 'fitness.tracker.connected.to.id' | translate : { fgbdefault: 'ID' } }} {{ fitnessTracker.UserId }}
            </ng-container>
            <ng-template #notConnectedStatus>
              {{ 'fitness.tracker.not-connected' | translate : { fgbdefault: 'Not connected' } }}
            </ng-template>
          </span>
        </div>
      </div>

      <button
        *ngIf="!fitnessTracker.HasConnection; else disconnectAction"
        type="button"
        class="fitness-tracker-connect-btn"
        (click)="connectFitnessTracker(fitnessTracker.ProviderId)"
      >
        {{ 'fitness.tracker.connect.button' | translate : { fgbdefault: 'Connect' } }}
      </button>
      <ng-template #disconnectAction>
        <button
          type="button"
          class="fitness-tracker-disconnect-btn"
          (click)="removeFitnessTracker(fitnessTracker.ProviderId)"
          attr.aria-label="{{ 'fitness.tracker.disconnect.button' | translate : { fgbdefault: 'Disconnect' } }}"
        >
          <span class="material-symbols-outlined text-danger d-none d-lg-inline" aria-hidden="true">delete</span>
          <span class="d-lg-none">{{ 'fitness.tracker.disconnect.button' | translate : { fgbdefault: 'Disconnect' } }}</span>
        </button>
      </ng-template>
    </div>
  </div>
</ng-container>
